import React from 'react';
import { Link } from 'react-router-dom';
import Button from "./ui/Button";
import { 
  Facebook, 
  Instagram, 
  Twitter, 
  Mail, 
  Phone, 
  MapPin, 
  Clock,
  Send
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-rose-300 text-gray-800  pb-8">
      <div className="max-w-6xl mx-auto px-4 py-12 md:px-0 px-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold mb-4">Piel Perfecta</h3>
            <p className="text-sm leading-relaxed">
              Experience luxury skincare and wellness at Piel Perfecta. We're dedicated to helping you achieve your beauty and relaxation goals through personalized treatments and expert care.
            </p>
          </div>

          {/* Quick Links */}
          <div className="grid grid-cols-2 gap-8 md:gap-4">
            <div>
              <h3 className="text-lg font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="../" className="hover:text-pink-600 transition-colors">Home</Link></li>
                <li><Link to="../about" className="hover:text-pink-600 transition-colors">About Us</Link></li>
                <li><Link to="../ecommerce" className="hover:text-pink-600 transition-colors">Products</Link></li>
                <li><Link to="../booking" className="hover:text-pink-600 transition-colors">Booking</Link></li>
                <li><Link to="../academy" className="hover:text-pink-600 transition-colors">Academy</Link></li>
                <li><Link to="../faq" className="hover:text-pink-600 transition-colors">FAQ</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-bold mb-4">Services</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="../massage-therapy" className="hover:text-pink-600 transition-colors">Massage</Link></li>
                <li><Link to="../ecommerce" className="hover:text-pink-600 transition-colors">Skin Care</Link></li>
                <li><Link to="../academy" className="hover:text-pink-600 transition-colors">Training</Link></li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-4 text-sm">
              {/* <li className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-pink-600" />
                <span>123 Spa Street, Beauty City, BC 12345</span>
              </li> */}
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-pink-600" />
                <span>(+234) 816 2298 183</span>
              </li>
              {/* <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-pink-600" />
                <span>info@pielperfecta.com</span>
              </li> */}
              <li className="flex items-center space-x-2">
                <Clock className="w-4 h-4 text-pink-600" />
                <div>
                  <p>Mon-Sun: 9:00 AM - 5:00 PM</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Newsletter & Booking */}
          <div className="space-y-6 md:px-0 pr-12">
            {/* <div>
              <h3 className="text-lg font-bold mb-4">Newsletter</h3>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="px-4 py-2 rounded-l w-full border-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-600 text-sm"
                />
                <button className="bg-pink-600 text-white px-4 py-2 rounded-r hover:bg-pink-700 transition-colors">
                  <Send className="w-4 h-4" />
                </button>
              </div>
            </div> */}

            <div>
              <Button 
                to="../booking" 
                variant="accent" 
                size="medium"
                className="w-full justify-center"
              >
                BOOK AN APPOINTMENT
              </Button>
            </div>
          
          {/* Payment Methods */}
            <div className="text-sm">
              <h4 className="font-bold mb-2">We Accept</h4>
              <div className="flex space-x-2">
                <span className="px-2 py-1 bg-green-500 text-white rounded text-xs">VISA</span>
                <span className="px-2 py-1 bg-blue-500 text-white rounded text-xs">MASTERCARD</span>
                <span className="px-2 py-1 bg-violet-500 text-white rounded text-xs">VERVE</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-400">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div className="text-center md:text-left">
              © 2025 Piel Perfecta. All rights reserved
            </div>
            <div className="text-center md:text-right space-x-4">
              <Link to="../privacy-policy" className="hover:text-pink-600 transition-colors">Privacy Policy</Link>
              <Link to="../terms-of-service" className="hover:text-pink-600 transition-colors">Terms of Service</Link>
              {/* <Link to="../" className="hover:text-pink-600 transition-colors">Cookie Policy</Link */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;